// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__GpMsg {
  width: fit-content;
  cursor: pointer;
  border-radius: 24px;
  border: 1px solid #eeeeee;
  padding: 8px 18px;
  margin: 0 4px;
  background-color: #fafafa;
  font-size: 14px;
  display: inline-block;
  height: 36px;
}
.styles_container__GpMsg .styles_wrapper__bqU3m {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.styles_container__GpMsg .styles_wrapper__bqU3m .styles_text__rCch8 {
  margin: -3px;
  color: #707070;
}

.styles_inputContainer__vrEp3 {
  margin-bottom: 20px;
  width: 100%;
}

.styles_wrapper__bqU3m {
  width: 100%;
}

.styles_container__GpMsg:active,
.styles_container__GpMsg:focus {
  background-color: #646464;
}
.styles_container__GpMsg:active .styles_text__rCch8,
.styles_container__GpMsg:focus .styles_text__rCch8 {
  color: #d9d9d9;
}

.styles_containerPadding__1rsvE {
  padding-right: 2rem;
  padding-left: 2rem;
}

.styles_formContainer__1zNAD > div {
  max-width: 400px;
}

.styles_extraMargin__I-8UZ {
  margin-top: 10px;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 20px;
}

@media only screen and (max-width: 1024px) {
  .styles_containerPadding__1rsvE {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
}
.styles_formContainer__1zNAD {
  border-left-width: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: auto;
  display: flex;
  padding: 20px;
}

.styles_submitItem__AfOpI {
  margin: 0 5px !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border-radius: 6px !important;
  background-color: inherit !important;
  font-size: 16px !important;
  line-height: 25px !important;
  height: auto !important;
}

.styles_submitItem__AfOpI span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

@media only screen and (max-width: 800px) {
  .styles_submitItem__AfOpI {
    border: none;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 19px !important;
    width: 100%;
    border: unset !important;
  }
}
.styles_haveAccount__1MxQN {
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: auto;
  display: flex;
  margin-top: 14px;
  margin-bottom: 40px;
}

.styles_bottomTexts__4hlQV {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 9px;
}

.styles_bottomTexts__4hlQV > p:nth-child(1) {
  margin: 5px;
}

.styles_flexStyle__nHzHg {
  flex-direction: row;
  border-radius: 10px;
  height: auto;
  width: auto !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles_formButton__ox5hU {
  width: 100% !important;
}

.styles_formButton__ox5hU > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__nHzHg {
    flex-direction: column;
  }
  .styles_flexStyle__nHzHg > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__1zNAD {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_force_media__k8GLr {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__nHzHg {
    flex-direction: column-reverse;
    overflow: auto;
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__nHzHg::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__nHzHg::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__nHzHg > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ForgetPassword/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;AACJ;AACI;EACE,YAAA;EACA,cAAA;AACN;;AAGA;EACE,mBAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAEA;;EAEE,yBAAA;AACF;AACE;;EACE,cAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AACA;EAEE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE;IACE,qBAAA;IACA,oBAAA;EACF;AACF;AAEA;EACE,sBAAA;EAGA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EAEA,aAAA;AAHF;;AAMA;EACE,wBAAA;EACA,eAAA;EACA,2BAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,uBAAA;AANF;;AAQA;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AANF;;AAQA;EAEE;IACE,YAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;IACA,4BAAA;IACA,WAAA;IACA,wBAAA;EANF;AACF;AASA;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAPF;;AASA;EAEE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAPF;;AASA;EACE,WAAA;AANF;;AAQA;EACE,mBAAA;EAGA,mBAAA;EAGF,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AATA;;AAWA;EACE,sBAAA;AARF;;AAUA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPF;;AAWA;EACE;IACE,sBAAA;EARF;EAWA;IACE,cAAA;IACA,gBAAA;EATF;EAWA;IACE,sBAAA;EATF;AACF;AAaA;EACE;IACE,iCAAA;EAXF;EAaA;IACE,8BAAA;IACA,cAAA;IAEA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EAdF;EAgBA;IAEE,uBAAA;IACA,UAAA;EAfF;EAkBA;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EAhBF;EAmBA;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EAjBF;AACF","sourcesContent":[".container {\n  width: fit-content;\n  cursor: pointer;\n  border-radius: 24px;\n  border: 1px solid #eeeeee;\n  padding: 8px 18px;\n  margin: 0 4px;\n  background-color: #fafafa;\n  font-size: 14px;\n  display: inline-block;\n  height: 36px;\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n\n    .text {\n      margin: -3px;\n      color: #707070;\n    }\n  }\n}\n.inputContainer{\n  margin-bottom:20px;\n  width:100%;\n\n}\n.wrapper{\n  width:100%;\n}\n.container:active,\n.container:focus {\n  background-color: #646464;\n\n  .text {\n    color: #d9d9d9;\n  }\n}\n\n.containerPadding {\n  padding-right: 2rem;\n  padding-left: 2rem;\n}\n.formContainer>div{\n  // min-width:30vw;\n  max-width:400px;\n\n}\n.extraMargin{\n  margin-top:10px;\n  margin-bottom:0;\n  font-weight: bold;\n  font-size: 20px;\n\n}\n@media only screen and (max-width: 1024px) {\n  .containerPadding {\n    padding-right: 1.5rem;\n    padding-left: 1.5rem;\n  }\n}\n\n.formContainer {\n  border-left-width: 2px;\n  // padding-left: 1.5rem;\n  // padding-right: 1.5rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: auto;\n  display: flex;\n\n  padding: 20px;\n\n}\n.submitItem {\n  margin: 0 5px !important;\n  cursor: pointer;\n  flex-direction: row-reverse;\n  // border: 1px solid #d8000d !important;\n  border-radius: 6px !important;\n  background-color: inherit !important;\n\n  font-size: 16px !important;\n  line-height: 25px !important;\n  // color: #e30813 !important;\n  height: auto !important;\n}\n.submitItem span {\n  // color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n@media only screen and (max-width: 800px) {\n\n  .submitItem {\n    border: none;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    font-size: 12px !important;\n    line-height: 19px !important;\n    width: 100%;\n    border: unset !important;\n  }\n}\n\n.haveAccount {\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  width: auto;\n  display: flex;\n  margin-top: 14px;\n  margin-bottom: 40px;\n}\n.bottomTexts{\n  // color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top:9px;\n}\n.bottomTexts>p:nth-child(1){\n  margin:5px;\n}\n.flexStyle {\n  flex-direction: row;\n  // margin-top:40px;\n\n  border-radius: 10px;\n// border: 1px solid rgba(0, 0, 0, 0.50);\n// background: #FFF;\nheight:auto;\nwidth:auto !important;\nmargin-top:10px;\nmargin-bottom:10px;\n}\n.formButton{\n  width:100% !important;\n}\n.formButton>button{\n  width:100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n\n@media only screen and (max-width: 1024px) {\n  .flexStyle {\n    flex-direction: column;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0 auto;\n    margin-top: 20px;\n  }\n  .formContainer {\n    border-left-width: 0px;\n  }\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .force_media {\n    padding: 0 10px 0 10px !important;\n  }\n  .flexStyle {\n    flex-direction: column-reverse;\n    overflow: auto;\n    // height: calc( 100vh - 138px);\n    padding-bottom: 20px;\n  \n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n  .flexStyle::-webkit-scrollbar {\n  \n    background: transparent;\n    width: 8px;\n  }\n  \n  .flexStyle::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0;\n    margin-top: 20px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__GpMsg`,
	"wrapper": `styles_wrapper__bqU3m`,
	"text": `styles_text__rCch8`,
	"inputContainer": `styles_inputContainer__vrEp3`,
	"containerPadding": `styles_containerPadding__1rsvE`,
	"formContainer": `styles_formContainer__1zNAD`,
	"extraMargin": `styles_extraMargin__I-8UZ`,
	"submitItem": `styles_submitItem__AfOpI`,
	"haveAccount": `styles_haveAccount__1MxQN`,
	"bottomTexts": `styles_bottomTexts__4hlQV`,
	"flexStyle": `styles_flexStyle__nHzHg`,
	"formButton": `styles_formButton__ox5hU`,
	"force_media": `styles_force_media__k8GLr`
};
export default ___CSS_LOADER_EXPORT___;
